import React, { FC } from 'react';
import { Button, Col, Divider, Row, Typography } from 'components';
import { EditIcon, PlusIcon } from 'components/common/icons';
import styles from './styles.module.scss';

const { Text } = Typography;

interface IEditableInfoComponent {
  title: string;
  icon?: React.ReactNode;
  editable?: boolean;
  disabled?: boolean;
  creatable?: boolean;
  onEdite?: () => void;
  onAdd?: () => void;
  children?: React.ReactNode;
}

export const EditableInfoComponent: FC<IEditableInfoComponent> = React.memo((props) => {
  const { editable = true, creatable = false, disabled = false, onEdite, icon, title, onAdd, children } = props;
  return (
    <Row className={styles.editable_info} gutter={[0, 12]}>
      <Col span={24}>
        <Row align={'middle'} justify={'space-between'}>
          <Col style={{ height: '34px' }}>
            <Row className={styles.title_container} align={'middle'}>
              {icon && <Col className={styles.icon_wrapper}>{icon}</Col>}
              <Col>
                <Text style={{ color: '#05796B' }} className={'font-weight-600'}>
                  {title}
                </Text>
              </Col>
              {creatable && (
                <Col className={styles.button}>
                  <Button
                    disabled={disabled}
                    block
                    variant={'outlined'}
                    size={'middle'}
                    color={'primary'}
                    onClick={onAdd}
                    icon={<PlusIcon size={'small'} color={'#05796B'} />}
                  >
                    Add New
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
          {editable && <Button type={'link'} icon={<EditIcon />} title={'Edit'} onClick={onEdite} />}
        </Row>
      </Col>
      <Col span={24}>
        <Divider className={styles.divider} />
      </Col>
      <Col span={24}>{children}</Col>
    </Row>
  );
});
